import { ExamStatus } from '$synapse/models';

export interface AvatarStyle {
  title: string;
  icon: string;
  classColor: string;
}

export const avatarStyle: Record<ExamStatus, AvatarStyle> = {
  UNREAD: {
    title: 'Non Consulté',
    icon: 'block',
    classColor: 'dark',
  },
  PENDING: {
    title: 'Non Commencé',
    icon: 'hourglass_empty',
    classColor: 'dark',
  },
  IN_PROGRESS: {
    title: 'En cours',
    icon: 'hourglass_top',
    classColor: 'pending',
  },
  SUCCEEDED: {
    title: 'Réussi',
    icon: 'check_circle',
    classColor: 'success',
  },
  EXPIRED: {
    title: 'Expiré',
    icon: 'cancel',
    classColor: 'dark',
  },
  FAILED: {
    title: 'Échoué',
    icon: 'cancel',
    classColor: 'danger',
  },
};
